import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { LoadingController, PopoverController, ToastController } from '@ionic/angular';
import { UserAddressInPutDto } from 'src/app/generate-client/model/userAddressInPutDto';
import { UserAddressOutPutDto } from 'src/app/generate-client';
import { LocalStorageService } from 'src/app/services/local-storage-service.service';
import { UserAddressService } from '../../generate-client/api/userAddress.service';

import { Geolocation, Geoposition } from "@ionic-native/geolocation/ngx";
import { NativeGeocoder, NativeGeocoderResult, NativeGeocoderOptions } from "@ionic-native/native-geocoder/ngx";

declare var google;

@Component({
  selector: 'app-new-adress',
  templateUrl: './new-adress.component.html',
  styleUrls: ['./new-adress.component.scss'],
})
export class NewAdressComponent implements OnInit {
  @ViewChild("map", { static: false })
  mapElement: ElementRef;

  map: any;
  lat: number;
  lng: number;
  loading: HTMLIonLoadingElement;
  error: string = '';

  constructor(
    private fb: FormBuilder,
    private loadingController: LoadingController,
    private popover: PopoverController,
    private localStorageService: LocalStorageService,
    private _userAddresService: UserAddressService,
    private toastController: ToastController,
    public geolocation: Geolocation,
    public nativeGeocoder: NativeGeocoder,
  ) { }
  adressForm = this.fb.group({
    alias: ["", Validators.compose([Validators.required, Validators.maxLength(25)])],
    street: ["", Validators.compose([Validators.required, Validators.maxLength(50)])],
    number: ["", Validators.compose([Validators.required])],
    apartment: [""]
  })

  ngOnInit() {
    this.loadMap();
  }

  async loadMap() {

    this.geolocation.getCurrentPosition().then((resp: Geoposition) => {

        let latLng = new google.maps.LatLng(resp.coords.latitude, resp.coords.longitude);

        let mapOptions = {
          center: latLng,
          zoom: 17,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        };

        this.getAddressFromCoords(resp.coords.latitude, resp.coords.longitude);

        this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);

        this.map.addListener("tilesloaded", () => {
          this.getAddressFromCoords(this.map.center.lat(), this.map.center.lng());
        });

        this.map.addListener("dragend", () => {
          this.getAddressFromCoords(this.map.center.lat(), this.map.center.lng());
        });
      })
      .catch((error) => {
        console.log("Error obteniendo ubicación", error);
      });
  }

  private async getAddressFromCoords(lattitude: number, longitude: number) {

    this.lat = lattitude;
    this.lng = longitude;

    let options: NativeGeocoderOptions = {
      useLocale: true,
      maxResults: 5,
    };

    this.nativeGeocoder.reverseGeocode(lattitude, longitude, options)
      .then((result: NativeGeocoderResult[]) => {
        let addr = result[0];

        this.adressForm.controls['street'].setValue(addr.thoroughfare);
        this.adressForm.controls['number'].setValue(Number(addr.subThoroughfare));
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  private async presentToast(txt: string) {

    const toast = await this.toastController.create({
      message: txt,
      position: 'top',
      duration: 2000
    });

    toast.present();
  }

  get street() {
    return this.adressForm.get('street');
  }

  get alias() {
    return this.adressForm.get('alias');
  }

  get number() {
    return this.adressForm.get('number')
  }

  get apartment() {
    return this.adressForm.get('apartment')
  }

  public async add() {

    this.error = '';

    this.loading = await this.loadingController.create({
      message: 'Agregando dirección...',
    });

    this.loading.present();

    let data: UserAddressInPutDto = {
      cdUser: parseInt(this.localStorageService.getUserId()),
      dsAlias: this.alias.value,
      dsStreet: this.street.value,
      nmStreetNumber: this.number.value,
      dsApartmentFloor: this.apartment.value,
      qtLat: this.lat,
      qtLng: this.lng,
      dsComments: ""
    }

    this._userAddresService.apiUserAddressPostUserAddressPost(data).subscribe( async (response: UserAddressOutPutDto) => {
      if (response.cdUserAddress) {
        await this.loading.dismiss();
        await this.popover.dismiss(true)
      }

    }, (error) => {
      this.error = error.error.error ?? "Ocurrio un error, vuelva a intentarlo mas tarde";
    });
  }
}
